import {TreatmentTarget} from './treatment_target'
export class RepCodeTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  validate() {
    let response = {}
    return response;
  }

  getData() {
    return {type:"REP_CODE", action_timing: 6 }
  }

  isTarget() {
    return false;
  }

  getIcon() {
    return 'fa-user-headset'
  }

  static getType() {
    return "REP_CODE"
  }

  connectedCallback() {
    this.innerHTML = 
      `<div class="col-sm-12 ct_action" data-action_type=REP_CODE>
        <div class="panel panel-default">
          <h4>Request Representative Code</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
          <p style="margin:10px;">The Sales Representative will be requested to enter their Representative Code.</p>
        </div>
      </div>
      <div class="col-sm-12 ct_line">
        <div class="ct_vertical_arrow"></div>
        <div class="option_text">Representative Code Entered</div>
        <div class="ct_vertical_arrow">
          <div class=arrow-down></div>
        </div>
      </div>
    `;
    super.connectedCallback();
  }
}

customElements.define('rep-code-treatment', RepCodeTreatment);